import React from 'react'
import {Link} from 'react-router-dom'
import Text from 'react-text'
import {Consumer} from '../../context'
import './navigation.styl'

export default function Navigation() {
  return (<Consumer>{ (context) => {
    const {page, profile, translate} = context
    const personName = profile.individual ? profile.individual.first_name : ''
    document.title = translate(`${page}_title`)
    return (
      <header className="navigation">
        <span className='current-page'>
         <Link to={context.link({},'/:languageId/:role/:page',{preserverQuery: false})}>
            {translate(`${page}_title`)}
          </Link>
        </span>
        <label className="welcome-message">
            {`${translate('welcome')},   ${personName}`}
        </label>
      </header>
    )
  }}</Consumer>)
}
